var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from '../Card';
import { EventContent } from './EventContent';
/**
 * Event shows various health-related tasks. It consist of a Card component wrapped
 * around EventContent component.
 *
 * @param cardProps - Props for Card component wrapped around EventContent
 * @param eventContentProps - Props for EventContent component
 * @returns Event component
 */
export const Event = (props) => {
    const { eventContentProps } = props, cardProps = __rest(props, ["eventContentProps"]);
    return (_jsx(Card, Object.assign({}, cardProps, { children: _jsx(EventContent, Object.assign({}, eventContentProps)) })));
};
